var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style[`cc-popbox-cheer`]},[_c('IconCheerAnimate',{attrs:{"size":120,"color":_vm.iconColor}}),_c('span',{staticClass:"font-medium",class:_vm.$style[`cc-popbox-cheer-info`]},[_vm._v(_vm._s(_vm.textInfo))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }